import type { ITableHeader } from "@/shared/components"
import { cn } from "@/shared/lib/utils.ts"

interface IProps {
  headers: ITableHeader[][]
}

export function EnergyPassportTableHeadDrawer({ headers }: IProps) {
  return (
    <thead className="sticky top-0 z-40">
      {headers.map((row, rowIndex) => (
        <tr key={rowIndex}>
          {Array.isArray(row) ? (
            row.map((header, index) => (
              <th
                key={index}
                rowSpan={header.rowSpan}
                colSpan={header.colSpan}
                style={header.style}
                className={cn(header.className, "!h-[32px] !py-0 text-sm")}
              >
                {header.label}
              </th>
            ))
          ) : (
            <th key={rowIndex}>-</th>
          )}
        </tr>
      ))}
    </thead>
  )
}
